import { BADGE_COLOR } from "@/constants/badgeColor";
import { cn } from "@/utils/cn";

const DOT_COLOR_MAP = {
  green: BADGE_COLOR.green,
  red: BADGE_COLOR.red,
  yellow: BADGE_COLOR.yellow,
};

export function Badge({
  children,
  className,
  dotColor,
}: {
  children: React.ReactNode;
  className?: string;
  dotColor?: "green" | "red" | "yellow";
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-md bg-primaryLight px-2 py-1 text-xs font-medium text-gray-900",
        className
      )}
    >
      {dotColor !== undefined && (
        <span
          className="h-2.5 w-2.5 flex-shrink-0 rounded-full"
          style={{ backgroundColor: DOT_COLOR_MAP[dotColor] }}
        />
      )}
      {children}
    </span>
  );
}
